import React, { useCallback, useEffect, useState } from "react";
import { Form, Background } from "./styled";
import Input from "../../components/Input";
import image from "./res/image.svg";
import logo from "./res/logo.png";
import { RootState } from "../../store";
import { Authentication } from "../../../domain/usecases";
import { Validation } from "../../protocols";
import { useLocation, useNavigate } from "react-router-dom";
import { AccountModel } from "../../../domain/models";
import { useSelector } from "react-redux";
import Loading from "../../components/Loading";

type Props = {
  authentication: Authentication;
  validation: Validation;
};

export const Login: React.FC<Props> = ({ authentication, validation }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [username, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [usernameTouched, setUserNameTouched] = useState<boolean>(false);
  const [passwordTouched, setPasswordTouched] = useState<boolean>(false);
  const [mainError, setMainError] = useState<any>("");
  const [usernameError, setUsernameError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const redirected = location?.state?.redirected;

  const setCurrentAccount = useSelector<
    RootState,
    (account: AccountModel | undefined) => void
  >((state) => state.setCurrentAccount);

  const validate = useCallback(
    (field: "username" | "password"): void => {
      const formData = { username, password };
      field === "username" &&
        setUsernameError(validation.validate(field, formData));
      field === "password" &&
        setPasswordError(validation.validate(field, formData));
      setIsFormValid(!usernameError && !passwordError);
    },
    [password, passwordError, username, usernameError, validation]
  );

  useEffect(() => {
    validate("username");
  }, [validate]);

  useEffect(() => {
    validate("password");
  }, [validate]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      if (isLoading || !isFormValid) {
        return;
      }
      setIsLoading(true);
      const account = await authentication.auth({
        username,
        password,
      });

      await setCurrentAccount(account);
      setIsLoading(false);
      if (redirected) {
        return navigate(redirected);
      }
      return navigate("/");
    } catch (error: any) {
      if (error.message) {
        setMainError(error.message);
      }
      setIsLoading(false);
    }
  };

  return (
    <Background>
      <Loading isLoading={isLoading} />
      <img className="image" src={`${image}`} />
      <div className="out-container">
        <div>
          <img className="logo" src={logo} />
        </div>
        <span>Solução para Gestão de Armazéns</span>
        <div className="container">
          <div className="title">
            <h1>Login</h1>
          </div>
          <Form onSubmit={handleSubmit}>
            <div className="fieldError">
              {usernameTouched ? usernameError : ""}
            </div>
            <Input
              type="text"
              id="username"
              placeholder="Usuário"
              value={username}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setUserName(e.target.value);
              }}
              onBlur={() => {
                if (!usernameTouched) setUserNameTouched(true);
              }}
            />

            <div className="fieldError">
              {passwordTouched ? passwordError : ""}
            </div>

            <Input
              type="password"
              id="senha"
              placeholder="Senha"
              value={password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPassword(e.target.value);
              }}
              onBlur={() => {
                if (!passwordTouched) setPasswordTouched(true);
              }}
            />

            <button type="submit">ACESSAR</button>
          </Form>
        </div>
      </div>
    </Background>
  );
};
